export default "__VITE_ASSET__Cpdpfmc3__"